import _Vue from "vue";
import {OpeningHoursInterface} from "@/shared/interfaces/OpeningHoursInterface";
import {LocationInterface} from "@/shared/interfaces/LocationInterface";

export type TranslationDefinitionType = { [key: string]: string };

export function OpeningHours(Vue: typeof _Vue): void {

    function getOpeningHoursToday(_location: LocationInterface): OpeningHoursInterface | null {
        const days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        const dayOfWeek = days[(new Date()).getDay()];
        if (!_location?.openingHours || typeof _location.openingHours === 'string') return null;

        const interval = 1000 * 60 * 60 * 24;
        const timestampToday = Math.floor(Date.now() / interval) * interval; // timestamps: start of today in GMT
        const foundSpecialOpeningHours = _location.specialOpeningHours?.find(openingHours => parseInt(openingHours.date ? openingHours.date : '') === timestampToday) || null;
        if(foundSpecialOpeningHours) {
            return foundSpecialOpeningHours;
        }
        return _location.openingHours.find(openingHours => openingHours.dayOfWeek === dayOfWeek) || null;
    }

    function parseTimeData(time: string | null): number {
        if (!time) return 0;
        const timeRegex = /^([0-9]{2}):([0-9]{2})/
        const match = time.match(timeRegex);
        if (match) {

            const hours = parseInt(match[1]);
            const minutes = parseInt(match[2]);

            return hours * 60 + minutes;
        }
        return -1;
    }

    function getCurrentTime(): number {
        const date = new Date();
        const hour = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours().toString();
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes().toString();

        return parseTimeData(`${hour}:${minutes}`);
    }

    Vue.prototype.$isLocationOpened = function (location: LocationInterface) {
        if(location.temporaryClosed) return false;
        const openingHours = getOpeningHoursToday(location);
        const now = getCurrentTime();
        if (!openingHours || openingHours.closed) return false;


        const from1 = parseTimeData(openingHours.from1);
        const to1 = parseTimeData(openingHours.to1);
        const from2 = parseTimeData(openingHours.from2);
        const to2 = parseTimeData(openingHours.to2);

        return (from1 <= now && to1 > now) || (from2 <= now && to2 > now);
    }

    Vue.filter('openingHours', (_location: LocationInterface) => {

        const openingHours = getOpeningHoursToday(_location);
        if (!openingHours || _location.temporaryClosed || openingHours.closed) return '';

        let result = `${openingHours.from1} - ${openingHours.to1}`;
        if (openingHours.from2 && openingHours.to2) {
            result += ` und ${openingHours.from2} - ${openingHours.to2}`;
        }
        return result;
    });

    Vue.filter('openingStatus', (location: LocationInterface) => {
        if(location.temporaryClosed) return 'vorrübergehend geschlossen';
        return Vue.prototype.$isLocationOpened(location) ? 'Jetzt geöffnet' : 'Jetzt geschlossen';
    })
}
